import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { formbricks, initFormbricks, isFormbricksReady } from './client';
import { useAuth } from '@/hooks/useAuth';

export function FormbricksBridge() {
  const location = useLocation();
  const { user } = useAuth();

  // 1) Init once a user is available; the login page should not depend on surveys.
  useEffect(() => {
    if (!user?.id) return;

    initFormbricks();
  }, [user?.id]);

  // 2) Route changes (SPA)
  useEffect(() => {
    if (!isFormbricksReady()) return;

    // Formbricks recommends calling registerRouteChange on navigation events
    formbricks.registerRouteChange();
  }, [location.pathname, location.search]);

  // 3) Identify the signed-in user (recommended for “App Surveys” segmentation)
  useEffect(() => {
    if (!user?.id) return;

    const ready = isFormbricksReady() || initFormbricks();
    if (!ready) return;

    // Formbricks supports setting user id & attributes
    formbricks.setUserId(user.id);
  }, [user?.id]);

  return null;
}
